import {Component, OnInit, ViewChild, AfterViewInit, ElementRef, Input} from '@angular/core';
import {BehaviorSubject, fromEvent} from 'rxjs';
import {switchMap, takeUntil, pairwise} from 'rxjs/operators'
import {WarningComponent} from "../../../../../../../shared/components/warning/warning.component";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {Message} from "../../../../../../../core/class/message";

declare var $: any;

@Component({
  selector: 'app-canvas-draw-moha',
  templateUrl: './canvas-draw-moha.component.html',
  styleUrls: ['./canvas-draw-moha.component.scss']
})
export class CanvasDrawMohaComponent implements OnInit, AfterViewInit {
  @ViewChild('myCanvas', {static: false}) canvas: ElementRef;
  private cx: CanvasRenderingContext2D;
  @Input() public width = 600;
  @Input() public height = 300;
  currentColour: string = '#000';
  brushSize: number = 5;
  private actions = new BehaviorSubject<string>('');
  private isFormChanging: false;


  constructor(
    public dialogRef: MatDialogRef<CanvasDrawMohaComponent>,
    private dialog: MatDialog,
    public message: Message,
  ) {
  }

  ngAfterViewInit() {
    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
    this.cx = canvasEl.getContext('2d');
    canvasEl.width = this.width;
    canvasEl.height = this.height;
    this.cx.lineWidth = 5;
    this.cx.lineCap = 'round';
    this.cx.strokeStyle = '#000';

    this.captureEvents(canvasEl);
  }

  private captureEvents(canvasEl: HTMLCanvasElement) {
    // this will capture all mousedown events from the canvas element
    fromEvent(canvasEl, 'mousedown')
      .pipe(
        switchMap((e) => {
          // after a mouse down, we'll record all mouse moves
          return fromEvent(canvasEl, 'mousemove')
            .pipe(
              // we'll stop (and unsubscribe) once the user releases the mouse
              // this will trigger a 'mouseup' event
              takeUntil(fromEvent(canvasEl, 'mouseup')),
              // we'll also stop (and unsubscribe) once the mouse leaves the canvas (mouseleave event)
              takeUntil(fromEvent(canvasEl, 'mouseleave')),
              // pairwise lets us get the previous value to draw a line from
              // the previous point to the current point
              pairwise()
            )
        })
      )
      .subscribe((res: [MouseEvent, MouseEvent]) => {
        const rect = canvasEl.getBoundingClientRect();

        // previous and current position with the offset
        const prevPos = {
          x: res[0].clientX - rect.left,
          y: res[0].clientY - rect.top
        };

        const currentPos = {
          x: res[1].clientX - rect.left,
          y: res[1].clientY - rect.top
        };

        // this method we'll implement soon to do the actual drawing
        this.drawOnCanvas(prevPos, currentPos);
      });
  }

  private drawOnCanvas(prevPos: { x: number, y: number }, currentPos: { x: number, y: number }) {
    if (!this.cx) {
      return;
    }

    this.cx.beginPath();
    if (prevPos) {
      this.cx.moveTo(prevPos.x, prevPos.y); // from
      this.cx.lineTo(currentPos.x, currentPos.y);
      this.cx.closePath();
      this.cx.strokeStyle = this.currentColour;
      this.cx.lineWidth = this.brushSize;
      this.cx.stroke();
    }
  }

  ngOnInit() {

  }

  changeColour(colour) {
    this.currentColour = colour;
  }

  changeSize(size) {
    this.brushSize = size;
  }

  clearCanvas() {
    // let ctx = this.canvasElement.getContext('2d');
    // ctx.clearRect(0, 0, this.canvasElement.width, this.canvasElement.height);
    this.cx.clearRect(0, 0, this.width, this.height);
  }

  onClickCancelButton() {

  }

  onNoClick() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '30%',
        data: this.message.getMessage('messages.confirm_change_data')
      });

      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

  onSaveCanvas() {
    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
    const dataURL = canvasEl.toDataURL();
    this.dialogRef.close({image: dataURL})
  }
}
